import React from 'react';

export default function ProgressBar({ value = 0, color = '#4A6CF7', height = 6, showLabel = false }) {
  const clamp = Math.max(0, Math.min(100, value));
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <div style={{ flex: 1, height, background: '#F3F4F6', borderRadius: 99, overflow: 'hidden' }}>
        <div style={{
          height: '100%', width: `${clamp}%`,
          background: clamp === 100 ? '#34C759' : clamp >= 50 ? color : '#FF9500',
          borderRadius: 99, transition: 'width 0.4s ease'
        }} />
      </div>
      {showLabel && <span style={{ fontSize: 12, fontWeight: 600, color: '#6B7280', minWidth: 32 }}>{clamp}%</span>}
    </div>
  );
}
